import { __assign } from "tslib";
import { Observable } from "../Misc/observable.js";
import { WebXRInputSource } from "./webXRInputSource.js";
import { WebXRMotionControllerManager } from "./motionController/webXRMotionControllerManager.js";
/**
 * XR input used to track XR inputs such as controllers/rays
 */
var WebXRInput = /** @class */ (function () {
    /**
     * Initializes the WebXRInput
     * @param xrSessionManager the xr session manager for this session
     * @param xrCamera the WebXR camera for this session. Mainly used for teleportation
     * @param _options = initialization options for this xr input
     */
    function WebXRInput(
    /**
     * the xr session manager for this session
     */
    xrSessionManager, 
    /**
     * the WebXR camera for this session. Mainly used for teleportation
     */
    xrCamera, _options) {
        if (_options === void 0) { _options = {}; }
        var _this = this;
        this.xrSessionManager = xrSessionManager;
        this.xrCamera = xrCamera;
        this._options = _options;
        /**
         * XR controllers being tracked
         */
        this.controllers = [];
        /**
         * Event when a controller has been connected/added
         */
        this.onControllerAddedObservable = new Observable();
        /**
         * Event when a controller has been removed/disconnected
         */
        this.onControllerRemovedObservable = new Observable();
        this._onInputSourcesChange = function (event) {
            _this._addAndRemoveControllers(event.added, event.removed);
        };
        // Remove controllers when exiting XR
        this._sessionEndedObserver = this.xrSessionManager.onXRSessionEnded.add(function () {
            _this._addAndRemoveControllers([], _this.controllers.map(function (c) {
                return c.inputSource;
            }));
        });
        this._sessionInitObserver = this.xrSessionManager.onXRSessionInit.add(function (session) {
            session.addEventListener("inputsourceschange", _this._onInputSourcesChange);
        });
        this._frameObserver = this.xrSessionManager.onXRFrameObservable.add(function (frame) {
            // Update controller pose info
            _this.controllers.forEach(function (controller) {
                controller.updateFromXRFrame(frame, _this.xrSessionManager.referenceSpace, _this.xrCamera);
            });
        });
        if (this._options.customControllersRepositoryURL) {
            WebXRMotionControllerManager.BaseRepositoryUrl = this._options.customControllersRepositoryURL;
        }
        WebXRMotionControllerManager.UseOnlineRepository = !this._options.disableOnlineControllerRepository;
        if (WebXRMotionControllerManager.UseOnlineRepository) {
            // pre-load the profiles list to load the controllers quicker afterwards
            try {
                WebXRMotionControllerManager.UpdateProfilesList().catch(function () {
                    WebXRMotionControllerManager.UseOnlineRepository = false;
                });
            }
            catch (e) {
                WebXRMotionControllerManager.UseOnlineRepository = false;
            }
        }
    }
    WebXRInput.prototype._addAndRemoveControllers = function (addInputs, removeInputs) {
        var _this = this;
        // Add controllers if they don't already exist
        var sources = this.controllers.map(function (c) {
            return c.inputSource;
        });
        for (var _i = 0, addInputs_1 = addInputs; _i < addInputs_1.length; _i++) {
            var input = addInputs_1[_i];
            if (sources.indexOf(input) === -1) {
                var controller = new WebXRInputSource(this.xrSessionManager.scene, input, __assign(__assign({}, (this._options.controllerOptions || {})), { forceControllerProfile: this._options.forceInputProfile, doNotLoadControllerMesh: this._options.doNotLoadControllerMeshes, disableMotionControllerAnimation: this._options.disableControllerAnimation }));
                this.controllers.push(controller);
                this.onControllerAddedObservable.notifyObservers(controller);
            }
        }
        // Remove and dispose of controllers to be disposed
        var keepControllers = [];
        var removedControllers = [];
        this.controllers.forEach(function (c) {
            if (removeInputs.indexOf(c.inputSource) === -1) {
                keepControllers.push(c);
            }
            else {
                removedControllers.push(c);
            }
        });
        this.controllers = keepControllers;
        removedControllers.forEach(function (c) {
            _this.onControllerRemovedObservable.notifyObservers(c);
            c.dispose();
        });
    };
    /**
     * Disposes of the object
     */
    WebXRInput.prototype.dispose = function () {
        this.controllers.forEach(function (c) {
            c.dispose();
        });
        this.xrSessionManager.onXRFrameObservable.remove(this._frameObserver);
        this.xrSessionManager.onXRSessionInit.remove(this._sessionInitObserver);
        this.xrSessionManager.onXRSessionEnded.remove(this._sessionEndedObserver);
        this.onControllerAddedObservable.clear();
        this.onControllerRemovedObservable.clear();
        // clear the controller cache
        WebXRMotionControllerManager.ClearControllerCache();
    };
    return WebXRInput;
}());
export { WebXRInput };
//# sourceMappingURL=webXRInput.js.map